import {Controller} from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
    connect() {
        const thumbsSwiper = new Swiper(this.element.querySelector('.ui-organism-galery__thumb'), {
            spaceBetween: 16,
            slidesPerView: 2.2,
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                }
            },
            freeMode: true,
            watchSlidesProgress: true,
        });

        this.mainSwiper = new Swiper(this.element.querySelector('.ui-organism-galery__main'), {
            navigation: {
                nextEl: ".ui-organism-galery__nav--next",
                prevEl: ".ui-organism-galery__nav--prev",
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    }
}